var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.caption)?_c('badge',{class:{ private: _vm.visibility === 0, network: _vm.visibility === 1, open: _vm.visibility === 2 }},[_vm._v("\n    "+_vm._s(_vm.caption)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }